export const iconFontAwesomeMediaplaybackEject = (
	<i className="fa-solid fa-eject"></i>
);
